/**
 * SelectInput — bottom-border native select. Goes inside a `<Field>` slot.
 * Visual chrome (border, label) is owned by Field; the chevron renders
 * inline so the select stays a real `<select>` for keyboard / a11y.
 * Source: .agents/design/project/artboard-radical-zakaznik-form.jsx:196-203
 */

import type { Ref, SelectHTMLAttributes } from 'react';
import { Icon } from './Icon';

interface SelectInputProps extends SelectHTMLAttributes<HTMLSelectElement> {
  ref?: Ref<HTMLSelectElement>;
}

export function SelectInput({
  className = '',
  children,
  ref,
  ...rest
}: SelectInputProps) {
  return (
    <>
      <select
        {...rest}
        ref={ref}
        className={
          'min-w-0 flex-1 appearance-none border-0 bg-transparent py-1 pr-6 font-mono text-[16px] tracking-[-0.01em] text-ink outline-none ' +
          className
        }
      >
        {children}
      </select>
      <Icon name="chevronD" size={14} className="-ml-5 text-ink-3" />
    </>
  );
}
